// extracted by mini-css-extract-plugin
export default {"content":"copy-to-clipboard_content__OD1Kr"};